// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31KOj","newExpiryDate":"styles_newExpiryDate__1XERS","footer":"styles_footer__31xKJ"};